import { SoltenantGroup } from '.';

export class SoltenantGroupDto {
    public soletenantGroup: SoltenantGroup;
    public action: string;
    constructor(data ? : any) {
        this.soletenantGroup = data && data.soletenantGroup ? data.soletenantGroup : null;
        this.action = data && data.action ? data.action : '';
    }
}